import React from "react";
import { Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative mt-32 border-t border-white/10 bg-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="text-display text-3xl tracking-wider text-white">LONE STAR <span className="text-adrenaline">SPEED</span></div>
          <p className="text-zinc-400 mt-4 max-w-md text-sm leading-relaxed">Texas-born custom wheels, performance gear, and street/strip culture. Limited drops for people who live speed.</p>
          <div className="flex items-center gap-4 mt-6">
            <a data-testid="ig-link" href="#" aria-label="Instagram" className="text-zinc-400 hover:text-adrenaline transition-colors"><Instagram size={20} /></a>
            <a data-testid="yt-link" href="#" aria-label="YouTube" className="text-zinc-400 hover:text-adrenaline transition-colors"><Youtube size={20} /></a>
            <a data-testid="tt-link" href="#" aria-label="TikTok" className="text-zinc-400 hover:text-adrenaline transition-colors text-mono text-sm tracking-wide">TIKTOK</a>
          </div>
        </div>
        <div>
          <div className="text-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">Shop</div>
          <ul className="space-y-3 text-zinc-300 text-sm">
            <li><a href="/apparel">Apparel</a></li>
            <li><a href="/gallery">Builds</a></li>
          </ul>
        </div>
        <div>
          <div className="text-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">Info</div>
          <ul className="space-y-3 text-zinc-300 text-sm">
            <li><a href="/about">About</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/returns">Returns & Refunds</a></li>
            <li className="text-zinc-500 text-mono text-xs">drops@lonestarspeedco.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-mono text-xs text-zinc-600 uppercase tracking-[0.3em]">© {new Date().getFullYear()} Lone Star Speed. Texas Born. Street Official.</p>
          <p className="text-mono text-xs text-zinc-600">v0.1 · STREET / STRIP</p>
        </div>
      </div>
    </footer>
  );
}
